<div class="mb-24 text-center" *ngIf="!!modalRef.data.description">
    {{ modalRef.data.description | translate }}
</div>

<div class="mb-24" *ngIf="!!modalRef.data.extraInfo" [innerHTML]="modalRef.data.extraInfo"></div>

<button
    type="button"
    class="btn btn--full"
    [class.btn-primary]="!modalRef.data.feel"
    [class.btn-feel]="modalRef.data.feel"
    (click)="modalRef.close(true)"
>
    {{ modalRef.data.confirm | translate }}
</button>
<button
    type="button"
    class="btn btn--full mt-16"
    [class.btn-secondary]="!modalRef.data.feel"
    [class.btn-secondary-feel]="modalRef.data.feel"
    (click)="modalRef.close(false)"
    *ngIf="modalRef.data.showCancel"
>
    {{ modalRef.data.cancel | translate }}
</button>
